import React, { useEffect } from 'react';
import VendorAccountability from '../components/VendorAccountability';

export default function VendorAccountabilityPage() {
  useEffect(() => {
    document.body.classList.add('analytics-page');
    return () => {
      document.body.classList.remove('analytics-page');
    };
  }, []);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f7fafc', paddingTop: '60px' }}>
      <VendorAccountability vendorId="vendor-001" isStaffView={true} />
    </div>
  );
}